export const initialState = {
  values: [],
  changed: false
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnPropertyDetailChanged':
      return onPropertyDetailChanged(state, action);
    case 'OnPropertyDetailAdded':
      return onPropertyDetailAdded(state, action);
    case 'OnPropertyDetailUpdated':
      return onPropertyDetailUpdated(state, action);
    case 'OnPropertyDetailDeleted':
      return onPropertyDetailDeleted(state, action);
    case 'OnCancelPropertyDetail':
      return onCancelPropertyDetail(state, action);
    case 'OnEditPropertyDetail':
      return onEditPropertyDetail(state, action);
    default:
      return state;
  }
}

function onInitState(state, action) {
  const { values } = action;
  const valuesWithInEdit = values.map(value => ({
    ...value,
    inEdit: false
  }));
  return {
    ...state,
    values: valuesWithInEdit,
    changed: false
  };
}

function onPropertyDetailChanged(state, action) {
  const { propName, propValue, index } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        [propName]: propValue
      }
    }),
    changed: true
  };
}

function onPropertyDetailAdded(state, action) {
  const newPropertyDetail = {
    propertyDetailId: null,
    propertyId: action.propertyId,
    propertyValue: '',
    description: null,
    orderNo: null,
    code: null,
    inactive: false,
    inEdit: true
  };
  const propertyDetails = state.values ? Object.assign([...state.values]) : [];
  propertyDetails.unshift({ ...newPropertyDetail });
  return {
    ...state,
    values: propertyDetails,
    changed: true
  };
}

function onPropertyDetailUpdated(state, _action) {
  return {
    ...state,
    changed: false
  };
}

function onPropertyDetailDeleted(state, action) {
  const { index } = action;
  const newPropertyDetails = Object.assign([...state.values]);
  newPropertyDetails.splice(index, 1);
  return {
    ...state,
    values: newPropertyDetails,
    changed: true
  };
}

function onCancelPropertyDetail(state, action) {
  const { index } = action;
  const updatedValues = state.values
    .map((value, idx) => (index === idx ? { ...value, ...value.editValue, inEdit: false } : value))
    .filter((value, idx) => {
      return idx !== index || value.propertyDetailId !== null;
    });
  return {
    ...state,
    values: updatedValues
  };
}

function onEditPropertyDetail(state, action) {
  const { index } = action;
  const updatedValues = state.values.map((value, idx) => {
    if (idx === index) {
      return {
        ...value,
        editValue: { ...value },
        inEdit: true
      };
    }
    return value;
  });

  return {
    ...state,
    values: updatedValues
  };
}
